import BetsShard from '@/common-pages/betsShard';
import ColorGame from '@/common-pages/color';
import DiceGame from '@/common-pages/dice/dice';
import Invitation, {
  InvitationApply,
  InvitationRecord,
  InvitationRule,
} from '@/common-pages/invitation';
import MixLottery from '@/common-pages/mix-lottery/mix-lottery';
import Promotion from '@/common-pages/promotion';
import MixLotteryDetail from '@/common-pages/result-detail/sate-lottery/mix-lottery-detail';
import Search from '@/common-pages/search';
import BetBy from '@/pages/betby/index';
import AddBank from './common-pages/add-bank/add-bank-progressive';
import AgentPage from './common-pages/agent/agent-page';
import Bets from './common-pages/bets';
import BetsDetail from './common-pages/bets-detail';
import Login, {SetPassword, SingUp} from './common-pages/login';
import NotificationPage from './common-pages/notification';
import NotificationDetail from './common-pages/notification/notification-detail';
import PaidSuccess from './common-pages/paid-success';
import Profile from './common-pages/profile';
import {
  ProxyCommissionDetail,
  ProxyCommissionDetailUser,
  ProxyNewUser,
  ProxyRules,
  ProxyTeamReport,
  ProxyTeamReportSearch,
} from './common-pages/proxy';
import Rebate from './common-pages/rebate';
import Recharge from './common-pages/recharge';
import {
  RechargeRecords,
  TransferRecords,
  WithdrawRecords,
} from './common-pages/records';
import Result from './common-pages/result';
import Transactions from './common-pages/transaction';
import Transfer from './common-pages/transfer';
import Vip from './common-pages/vip/vip';
import DetailWebView, {GameWebView} from './common-pages/webview';
import Withdraw from './common-pages/withdraw/withdraw-progressive';
import WithdrawSuccess from './common-pages/withdraw/withdraw-success-progressive';
import {BasicObject, NavigatorScreenProps} from './types';

type Route = {
  name: string;
  component: (props: NavigatorScreenProps & BasicObject) => React.JSX.Element;
  link: string;
  headerShown?: boolean;
};

const commonRoutes: Route[] = [
  {
    name: 'Promotion',
    component: Promotion,
    link: 'promotion',
  },
  {
    name: 'BetsShard',
    component: BetsShard,
    link: 'bets-shard',
  },
  {
    name: 'SingUp',
    component: SingUp,
    link: 'sing-up',
  },
  {
    name: 'Login',
    component: Login,
    link: 'login',
  },
  {
    name: 'SetPassword',
    component: SetPassword,
    link: 'set-password',
  },
  {
    name: 'Result',
    component: Result,
    link: 'result',
  },
  {
    name: 'Recharge',
    component: Recharge,
    link: 'recharge',
  },
  {
    name: 'Withdraw',
    component: Withdraw,
    link: 'withdraw',
  },
  {
    name: 'AddBank',
    component: AddBank,
    link: 'add-bank',
  },
  {
    name: 'WithdrawSuccess',
    component: WithdrawSuccess,
    link: 'withdraw-success',
  },
  {
    name: 'Vip',
    component: Vip,
    link: 'vip',
  },
  {
    name: 'PaidSuccess',
    component: PaidSuccess,
    link: 'paid-success',
  },
  {
    name: 'Rebate',
    component: Rebate,
    link: 'rebate',
  },
  {
    name: 'Bets',
    component: Bets,
    link: 'bets',
  },
  {
    name: 'BetsDetail',
    component: BetsDetail,
    link: 'bets-detail',
  },
  {
    name: 'Transactions',
    component: Transactions,
    link: 'transactions',
  },
  {
    name: 'Transfer',
    component: Transfer,
    link: 'transfer',
  },
  {
    name: 'RechargeRecords',
    component: RechargeRecords,
    link: 'recharge-records',
  },
  {
    name: 'WithdrawRecords',
    component: WithdrawRecords,
    link: 'withdraw-records',
  },
  {
    name: 'TransferRecords',
    component: TransferRecords,
    link: 'transfer-records',
  },
  {
    name: 'GameWebView',
    component: GameWebView,
    link: 'game-webview',
  },
  {
    name: 'WebView',
    component: DetailWebView,
    link: 'webview',
  },
  {
    name: 'Notification',
    component: NotificationPage,
    link: 'notification',
  },
  {
    name: 'NotificationDetail',
    component: NotificationDetail,
    link: 'notification-detail',
  },
  {
    name: 'AgentPage',
    component: AgentPage,
    link: 'agent-page',
  },
  {
    name: 'ProxyRules',
    component: ProxyRules,
    link: 'proxy-rules',
  },
  {
    name: 'ProxyCommissionDetail',
    component: ProxyCommissionDetail,
    link: 'proxy-commission-detail',
  },
  {
    name: 'ProxyCommissionDetailUser',
    component: ProxyCommissionDetailUser,
    link: 'proxy-commission-detail-user',
  },
  {
    name: 'ProxyTeamReport',
    component: ProxyTeamReport,
    link: 'proxy-team-report',
  },
  {
    name: 'ProxyTeamReportSearch',
    component: ProxyTeamReportSearch,
    link: 'proxy-team-report-search',
  },
  {
    name: 'ProxyNewUser',
    component: ProxyNewUser,
    link: 'proxy-new-user',
  },
  {
    name: 'Invitation',
    component: Invitation,
    link: 'invitation',
  },
  {
    name: 'InvitationApply',
    component: InvitationApply,
    link: 'invitation-apply',
  },
  {
    name: 'InvitationRecord',
    component: InvitationRecord,
    link: 'invitation-record',
  },
  {
    name: 'InvitationRule',
    component: InvitationRule,
    link: 'invitation-rule',
  },
  {name: 'Dice', component: DiceGame, link: 'dice'},
  {
    name: 'Color',
    component: ColorGame,
    link: 'color',
  },
  {
    name: 'Profile',
    component: Profile,
    link: 'profile',
  },
  {name: 'MixLottery', component: MixLottery, link: 'mix-lottery'},
  {
    name: 'MixLotteryDetail',
    component: MixLotteryDetail,
    link: 'mix-lottery-detail',
  },
  {
    name: 'search',
    component: Search,
    link: 'search',
  },
];

const customerRoutes: Route[] = [
  // 这里放各个盘需要的额外路由配置
  // 为了不破坏顶部的引用结构,请使用require的方式引入
  {
    name: 'PromotionDetail',
    component: require('./common-pages/promotion').PromotionDetail,
    link: 'promotion-detail',
  },
  {
    name: 'LiveCasino',
    component: require('./pages/live-casino').default,
    link: 'live-casino',
  },
  {
    name: 'Scratch',
    component: require('./pages/scratch').default,
    link: 'scratch',
  },
  {
    name: 'Lottery',
    component: require('./common-pages/lottery').default,
    link: 'lottery',
  },
  {
    name: 'Satta',
    component: require('./common-pages/satta/game-satta').default,
    link: 'satta',
  },
  {
    name: 'ScratchResultDetail',
    component: require('./common-pages/result-detail/scratch/scratch').default,
    link: 'scratch-result-detail',
  },
  {
    name: 'ScratchShare',
    component: require('./pages/new-scratch/share').default,
    link: 'scratch-share',
  },
  {
    name: 'BetBy',
    component: BetBy,
    link: 'BetBy',
  },
  {
    name: 'ProxyHome',
    component: require('./common-pages/proxy/proxy-home').default,
    link: 'proxy-home',
  },
  // {
  //   name: 'Chat',
  //   component: require('./common-pages/im/im-webview').default,
  //   link: 'chat',
  // },
  {
    name: 'PromotionsV2',
    component: require('./pages/promotions').default,
    link: 'promotionsv2',
  },
  {
    name: 'PromotionsV2History',
    component: require('./pages/promotions/history').default,
    link: 'promotionsv2-history',
  },
  {
    name: 'PromotionsV2Common',
    component: require('./pages/promotions/detail/common').default,
    link: 'promotionsv2-common',
  },
  {
    name: 'PromotionsV2Cumulate',
    component: require('./pages/promotions/detail/cumulate').default,
    link: 'promotionsv2-cumulate',
  },
  {
    name: 'PromotionsV2RechargeRebate',
    component: require('./pages/promotions/detail/recharge-rebate').default,
    link: 'promotionsv2-recharge-rebate',
  },
  {
    name: 'WeekCard',
    component: require('@/common-pages/vip/week-card').default,
    link: 'week-card',
  },
  {
    name: 'WeekCardBuyRecord',
    component: require('@/common-pages/vip/week-buy-record').default,
    link: 'week-card-buy-record',
  },
  // Agent 页面移至底部 EarnMoney Tab，不再作为独立栈路由
  {
    name: 'AgentDetail',
    component: require('./pages/agent/detail').default,
    link: 'agent-detail',
  },
  // Casino 作为普通栈路由供首页 gold-area 使用
  {
    name: 'Casino',
    component: require('./pages/casino').default,
    link: 'casino',
  },
  {
    name: 'Sports',
    component: require('./common-pages/sports/container').default,
    link: 'sports',
  },
];
// 这里新增FAQ模块下的所有路由
const faqRoutes: Route[] = [
  {
    name: 'GameRules',
    component: require('./pages/faq/help/gameRules').default,
    link: 'game-rules',
  },
  {
    name: 'Deposit',
    component: require('./pages/faq/help/deposit').default,
    link: 'deposit',
  },
  {
    name: 'Withdrawal',
    component: require('./pages/faq/help/withdrawal').default,
    link: 'withdrawal',
  },
  {
    name: 'Support',
    component: require('./pages/faq/help/support').default,
    link: 'support',
  },
  {
    name: 'DisResult',
    component: require('./pages/faq/info/disResult').default,
    link: 'dis-result',
  },
  {
    name: 'Gambling',
    component: require('./pages/faq/info/gambling').default,
    link: 'gambling',
  },
  {
    name: 'SelfExclusion',
    component: require('./pages/faq/info/selfExclusion').default,
    link: 'self-exclusion',
  },
  {
    name: 'PrivacyMag',
    component: require('./pages/faq/info/privacyMag').default,
    link: 'privacy-mag',
  },
  {
    name: 'Condition',
    component: require('./pages/faq/rupiibet/condition').default,
    link: 'condition',
  },
  {
    name: 'KYCPolicy',
    component: require('./pages/faq/rupiibet/kycPolicy').default,
    link: 'kyc-policy',
  },
  {
    name: 'Partner',
    component: require('./pages/faq/rupiibet/partner').default,
    link: 'partner',
  },
  {
    name: 'Policy',
    component: require('./pages/faq/rupiibet/policy').default,
    link: 'policy',
  },
  {
    name: 'PublicOffers',
    component: require('./pages/faq/rupiibet/publicOffers').default,
    link: 'public-offers',
  },
  {
    name: 'CheckIn',
    component: require('@/common-pages/check-in').default,
    link: 'check-in',
  },
  {
    name: 'AgentRules',
    component: require('@/common-pages/proxy/agent-rules').default,
    link: 'agent-rules',
  },
  {
    name: 'ScratchNew',
    component: require('@/pages/new-scratch').default,
    link: 'scratch-new',
  },
];

const routes: Route[] = [...commonRoutes, ...customerRoutes, ...faqRoutes];

export default routes;
